import { render } from "./MenuDropDownMul.vue?vue&type=template&id=3c794273"
import script from "./MenuDropDownMul.vue?vue&type=script&lang=js"
export * from "./MenuDropDownMul.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__